import { componentSearchData } from 'components/component-overview/state/component-search-data';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const useComponentSearchData = () => {
    const componentSearchDataSnapshot = useSnapshot(componentSearchData);

    return componentSearchDataSnapshot;
};

export { useComponentSearchData };
